import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const servicesData = [{
  title: "Project Management Implementation",
  description: "Expert delivery of complex portfolios with a focus on strategic alignment and milestone-based success. We lead high-stakes initiatives with senior-level precision.",
  deliverables: ["Portfolio Governance", "Risk Mitigation", "Milestone-Based Delivery", "Senior Practitioner Lead"],
  link: "/ServicesPage"
}, {
  title: "ServiceNow Implementation",
  description: "Seamless migration and optimization of your digital workflows using industry-leading expertise. We transform your operations through robust platform governance.",
  deliverables: ["ITSM Optimization", "Cloud Migration", "Workflow Automation", "Platform Governance"],
  link: "/ServicesPage"
}, {
  title: "Professional Training",
  description: "Elite certification courses including PMP, PRINCE2, and ACP delivered by practicing senior consultants. Empower your team with world-class methodologies.",
  deliverables: ["PMP Certification", "PRINCE2 Training", "Agile Methodologies", "Custom Corporate Workshops"],
  link: "/TrainingPage"
}];
export default function ServiceSpectrum() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="24258" id="consultancy-solutions" className="text-foreground py-24 relative overflow-hidden !bg-[hsl(210,16%,93%)]">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl translate-y-1/2 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-muted-foreground">
            Consultancy Solutions
          </h2>
          <p className="text-xl text-muted-foreground leading-relaxed font-sans">
            Projectora delivers senior-level project expertise focused on high-impact business outcomes. 
            From Auckland to the global stage, we lead with world-class precision and results-obsessed methodology.
          </p>
        </div>

        <div ref={ref} className="space-y-8">
          {servicesData.map((service, index) => {
          const isEven = index % 2 === 0;
          const bgClass = isEven ? "bg-card border-border/50" : "bg-secondary/40 border-border/30";
          return <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 border overflow-hidden group shadow-sm transition-shadow duration-500 border-border/30 !bg-[hsl(0,0%,100%)] hover:shadow-xl">
                  <CardContent className="p-0">
                    <div className="flex flex-col md:flex-row">
                      {}
                      

                      {}
                      <div className="p-8 flex flex-col justify-center !w-[970px] md:p-12">
                        <h3 className="text-3xl font-bold mb-4 group-hover:text-[hsl(174,100%,29%)] transition-colors duration-300 tracking-tight !text-[hsl(0,0%,0%)]">
                          {service.title}
                        </h3>
                        <p className="text-muted-foreground mb-8 text-lg leading-relaxed font-sans">
                          {service.description}
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                          {service.deliverables.map((item, i) => <div key={i} className="flex items-center gap-3">
                              <div className="flex-shrink-0 size-6 rounded-full bg-[hsl(174,100%,29%)]/10 flex items-center justify-center text-[hsl(174,100%,29%)]">
                                <Check className="size-3.5" />
                              </div>
                              <span className="text-sm font-medium text-foreground/80 font-sans">
                                {item}
                              </span>
                            </div>)}
                        </div>

                        <div>
                          <Button asChild variant="outline" className="group/btn border-primary/20 hover:border-[hsl(174,100%,29%)] hover:bg-[hsl(174,100%,29%)]/5 text-primary font-bold tracking-tight">
                            <Link to={service.link || "#"}>
                              Explore Outcome
                              <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                            </Link>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}